import styled from 'styled-components';

export const WarningContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 16px;
  background-color: #fde9ce;
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const WarningIcon = styled.div`
  color: #945605;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
`;

export const WarningText = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #945605;
  text-align: left;
`;
